import { Offcanvas } from "react-bootstrap"

export const OverCanvasDirect = ({ title, placement = "start", show = false, close = () => { }, children }) => {
    return <Offcanvas placement={placement} show={show} onHide={close}>
        {title ? <Offcanvas.Header closeButton>
            <Offcanvas.Title>{title}</Offcanvas.Title>
        </Offcanvas.Header> : null}
        <Offcanvas.Body>{children}</Offcanvas.Body>
    </Offcanvas>
}